<template>
  <edit-modal
    :caption="caption"
    :isActive="isActive">

    <div class="field">
      <div class="control">
        <input type="text" class="input" v-model="name" @keyup.enter="save()" placeholder="Nieuwe tabel maken">
      </div>
    </div>

    <save-buttons
      :disabled="!name"
      @save="save"
      @cancel="close">
    </save-buttons>

    <table v-if="table && table.bundles.length > 0" class="box table is-striped">
      <thead>
        <tr>
          <th>Bundels met data in de tabel {{ table.name }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="bundle in table.bundles" :key="bundle.id">
          <td>{{ bundle.name }}</td>
        </tr>
      </tbody>
    </table>
  </edit-modal>
</template>

<script>
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'table',
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      name: null
    }
  },
  computed: {
    caption () {
      return (this.table) ? `Tabel ${this.table.name} bewerken` : 'Nieuwe tabel'
    }
  },
  watch: {
    table () {
      this.name = (this.table) ? this.table.name : null
    }
  },
  methods: {
    save () {
      this.$emit('save', { name: this.name })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
